// extracted by mini-css-extract-plugin
export default {"root":"location-section_root__4b3Tr","locations":"location-section_locations__+ppnE"};